
import { Record, Union } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, lambda_type, unit_type, union_type, class_type, string_type, option_type, int32_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { FormState__getValidation, FormState__setValidationResponse_5219762A, FormState__startLoading, UpdateNotificationStockDto, StorageId__get_unwrap, FormState_get_empty, UpdateNotificationStockDto_$reflection, FormState_$reflection, StorageId_$reflection, ToolId_$reflection, ClientApiResponse$1_$reflection } from "../../../Shared/Shared.js";
import { Cmd_ofEffect, Cmd_batch, Cmd_none } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { postNotificationStockCmd } from "../../../Requests/ToolWithQuantity.js";
import { Cmd_successToast, Cmd_errorToast } from "../../../Components/Toast.js";
import { singleton as singleton_1, ofArray } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { empty, singleton, append, delay, toList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { NumberInput } from "../../../Components/Input.js";
import { unwrap, map } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { numberInputIntMaxValue } from "../../../Common.js";
import { ErrorAlert } from "../../../Components/Alert.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { Dialog } from "../../../Components/Dialog.js";
import { TextButton } from "../../../Components/Button.js";

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetQuantity", "UpdateNotificationStock", "UpdatedNotificationStockResponse", "FetchError"];
    }
}

function Msg_$reflection() {
    return union_type("Tools.MinimumStockQuantityDialog.Msg", [], Msg, () => [[["Item", option_type(int32_type)]], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", class_type("System.Exception")]]]);
}

class State extends Record {
    constructor(ToolId, StorageId, FormState, SuccessCallback, OnClose, Dto) {
        super();
        this.ToolId = ToolId;
        this.StorageId = StorageId;
        this.FormState = FormState;
        this.SuccessCallback = SuccessCallback;
        this.OnClose = OnClose;
        this.Dto = Dto;
    }
}

function State_$reflection() {
    return record_type("Tools.MinimumStockQuantityDialog.State", [], State, () => [["ToolId", ToolId_$reflection()], ["StorageId", StorageId_$reflection()], ["FormState", FormState_$reflection()], ["SuccessCallback", lambda_type(unit_type, unit_type)], ["OnClose", lambda_type(unit_type, unit_type)], ["Dto", UpdateNotificationStockDto_$reflection()]]);
}

function init(storageId, toolId, successCallback, onClose) {
    return [new State(toolId, storageId, FormState_get_empty(), successCallback, onClose, new UpdateNotificationStockDto(StorageId__get_unwrap(storageId), undefined)), Cmd_none()];
}

function update(msg, state) {
    switch (msg.tag) {
        case 1:
            return [new State(state.ToolId, state.StorageId, FormState__startLoading(state.FormState), state.SuccessCallback, state.OnClose, state.Dto), postNotificationStockCmd(state.ToolId, state.Dto, (Item) => (new Msg(2, [Item])), (Item_1) => (new Msg(3, [Item_1])))];
        case 2: {
            const response = msg.fields[0];
            if (response.tag === 1) {
                return [new State(state.ToolId, state.StorageId, FormState__setValidationResponse_5219762A(state.FormState, response.fields[0]), state.SuccessCallback, state.OnClose, state.Dto), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.ToolId, state.StorageId, FormState_get_empty(), state.SuccessCallback, state.OnClose, state.Dto), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                    state.SuccessCallback();
                }), Cmd_successToast("general.saved_successfully"), Cmd_ofEffect((_arg_1) => {
                    state.OnClose();
                })]))];
            }
        }
        case 3:
            return [new State(state.ToolId, state.StorageId, FormState_get_empty(), state.SuccessCallback, state.OnClose, state.Dto), Cmd_none()];
        default:
            return [new State(state.ToolId, state.StorageId, state.FormState, state.SuccessCallback, state.OnClose, new UpdateNotificationStockDto(state.Dto.StorageId, msg.fields[0])), Cmd_none()];
    }
}

function DialogBody(props) {
    let elems;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-4"])], (elems = toList(delay(() => {
        let Label, Value;
        return append(singleton(createElement(NumberInput, (Label = t("general.minimum_quantity"), (Value = map((value_1) => value_1, props.Quantity), {
            ComponentState: props.ComponentState,
            Label: unwrap(Label),
            MaxValue: numberInputIntMaxValue,
            OnChange: (arg) => {
                props.SetQuantity(map((value_2) => (~~value_2 | 0), arg));
            },
            TestId: "minimum-stock-quantity-input-test-id",
            ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "minimum_quantity")),
            Value: unwrap(Value),
        })))), delay(() => {
            const matchValue = FormState__getValidation(props.FormState, t, "global");
            if (matchValue == null) {
                return empty();
            }
            else {
                return singleton(createElement(ErrorAlert, {
                    Label: matchValue,
                }));
            }
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function MinimumStockQuantityDialog(props) {
    let Title;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.StorageId, props.ToolId, props.SuccessCallback, props.OnClose), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const componentState = state_1.FormState.IsLoading ? "disabled" : "enabled";
    return createElement(Dialog, (Title = t("tool.update_notification_stock"), {
        Body: singleton_1(createElement(DialogBody, {
            ComponentState: componentState,
            FormState: state_1.FormState,
            Quantity: unwrap(state_1.Dto.NotificationQuantity),
            SetQuantity: (value) => {
                dispatch(new Msg(0, [value]));
            },
        })),
        Controls: ofArray([createElement(TextButton, {
            ComponentState: componentState,
            Label: t("general.cancel"),
            OnClick: props.OnClose,
            TestId: "close-minimum-stock-quantity-dialog-test-id",
            Variant: "blueButton",
        }), createElement(TextButton, {
            ComponentState: componentState,
            Label: t("general.save"),
            OnClick: () => {
                dispatch(new Msg(1, []));
            },
            TestId: "save-minimum-stock-quantity-dialog-test-id",
            Variant: "blueButton",
        })]),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: Title,
    }));
}

